module.exports = __webpack_public_path__ + "img/person-brand.5dd529f9.svg";